




































































































import { Component, Vue } from 'vue-property-decorator';
import { ObjectFactory } from '../../config/objectFactory';
import { UpdatePartnerProfileRequest } from '../../types/request';
import { validationMixin } from 'vuelidate';
import { required, minLength, email } from 'vuelidate/lib/validators';
import { MapUtils } from '../../util/mapUtils';
import { MedTransGoConstants } from '../../util/constants';
import { CommonUtils } from '@/util/commonUtils';
declare var google: any;
// tslint:disable-next-line: no-var-requires
const TimeZones = require('../../config/timezones.json');
@Component({
    mixins: [validationMixin],
    data() {
        return {
            fullName: '',
            phone: '',
            email: '',
            companyName: '',
            timezone: '',
            address: {
                fullAddress: '',
                locality: '',
                state: '',
                city: '',
                zip: '',
            },
        };
    },
    validations() {
        const validations = {
            fullName: {
                required,
                regex: (fullName: string) => /^[a-zA-Z ]+$/.test(fullName),
            },
            phone: {
                required,
                minLength: minLength(10),
                regex: (phone: string) =>  MedTransGoConstants.PHONE_REGX.test(phone),
            },
            email: {
                required,
                email,
            },
            companyName: {
                required,
            },
            timezone: {
            required,
            },
            address: {
                fullAddress: {
                    required,
                },
                state: {
                    required,
                },
                city: {
                    required,
                },
                zip: {
                    required,
                },
            },
        };
        const personalInfo = this as UpdateUserProfileModal;
        if (!personalInfo.sessionInfo.scopes.includes('transporter')) {
            delete validations.companyName;
        }
        return validations;
    },
})

export default class UpdateUserProfileModal extends Vue {
    private locationGoogleAddress: any;
    private show = false;
    private sessionInfo = ObjectFactory.getCacheService().getSessionInfo();
    private TimeZones = TimeZones;
    public mounted() {
        this.show = true;
        this.getPartnerProfile();
        this.getGoogleAddress();
    }

    private async getPartnerProfile() {
        const partnerService = ObjectFactory.getPartnerService();
        const response = await partnerService.getPartnerProfile(this.$store.state.serverUrl);
        if (response.success && response.data) {
            const partnerProfile = response.data;
            if (partnerProfile.interpreterProfile) {
                this.$data.address = partnerProfile.interpreterProfile.address;
                this.$data.fullName = partnerProfile.interpreterProfile.fullname;
                this.$data.email = partnerProfile.interpreterProfile.email;
                this.$data.phone = partnerProfile.interpreterProfile.phone;
                this.$data.timezone = partnerProfile.interpreterProfile.timezone;
            }
            if (partnerProfile.transporterProfile) {
                this.$data.address = partnerProfile.transporterProfile.address;
                this.$data.fullName = partnerProfile.transporterProfile.fullname;
                this.$data.email = partnerProfile.transporterProfile.email;
                this.$data.phone = partnerProfile.transporterProfile.phone;
                this.$data.companyName = partnerProfile.transporterProfile.companyName;
                this.$data.timezone = partnerProfile.transporterProfile.timezone;
            }
        }
    }

    /**
     * @author <Aniket.P>
     * @description - google places
     * @param req {Request} - Express Request
     * @param res {Response} - Express Response - google places suggession
     * @returns google places suggession
     * @throws InvalidRequestException if network error
     */
    private async getGoogleAddress() {
        this.$root.$on('bv::modal::shown', (bvEvent: any, modalId: any) => {
            this.locationGoogleAddress = new google.maps.places.Autocomplete(
                document.getElementById('locationAddress'), {
                types: ['geocode'],
            },
            );
            this.locationGoogleAddress.addListener('place_changed', () => {
                this.$data.address = MapUtils.parseGoogleAddress(this.locationGoogleAddress);
            });
        });
    }

    private async updatePartnerProfile() {
        const partnerService = ObjectFactory.getPartnerService();
        const updateProfileResponse = await partnerService.updateUserProfile({
            email: this.$data.email,
            fullname: this.$data.fullName,
            phone: this.$data.phone,
            timezone: this.$data.timezone,
        }, this.$store.state.serverUrl);
        if (updateProfileResponse.success) {
            const updatePartnerProfileRequest: UpdatePartnerProfileRequest = {};
            if (this.sessionInfo.scopes.includes('interpreter')) {
                updatePartnerProfileRequest.interpreterProfile = {
                    address: this.$data.address,
                };
            }
            if (this.sessionInfo.scopes.includes('transporter')) {
                updatePartnerProfileRequest.transporterProfile = {
                    companyName: this.$data.companyName,
                    address: this.$data.address,
                };
            }
            const updatePartnerProfileResponse = await partnerService
                .updatePartnerProfile(updatePartnerProfileRequest, this.$store.state.serverUrl);
            if (updatePartnerProfileResponse.success) {
                this.close();
            }
        }
    }

    private close() {
        this.$router.push({
            name: MedTransGoConstants.VIEW_SETTING_NAME,
        });
    }

    private maskPhone(phone: string) {
        return CommonUtils.phoneNumberMask(phone);
    }
}
